import React from 'react';
import i18n from '@i18n';
import moment from 'moment';
import PropTypes from 'prop-types';

function FormattedDate({ startDate, dateFormat = 'DD.MM.' }) {
    const actualDate = moment();
    const momentDate = moment(startDate);
    let hours = momentDate.format('HH:mm');

    let day;
    if (momentDate.isSame(actualDate, 'day')) {
        day = i18n('commons.datum.dnes');
    } else {
        day = momentDate.format(dateFormat);
    }

    return (
        <>
            <span className="day">{day}</span>
            <span className="hours"> {hours}</span>
        </>
    );
}

FormattedDate.propTypes = {
    startDate: PropTypes.oneOfType([PropTypes.instanceOf(moment), PropTypes.string]),
    dateFormat: PropTypes.string
};

export default FormattedDate;
